export enum notificationTypes {
  bookingStarted = 'BOOKING_STARTED',
  signContract = 'SIGN_CONTRACT',
  requestSlot = 'REQUEST_SLOT',
  bookingFinished = 'BOOKING_FINISHED',
  accepted = 'BOOKING_ACCEPTED',
  // TO DO add more
}
